// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PresentationStringQueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
  presentationID: Types.Scalars['ID']['input'];
  hasPresentationID: Types.Scalars['Boolean']['input'];
}>;


export type PresentationStringQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & PresentationString_HouseholdFragment
      ) | null } | null> | null }, clientPresentationV2s?: { __typename?: 'ClientPresentationV2Connection', edges?: Array<{ __typename?: 'ClientPresentationV2Edge', node?: (
        { __typename?: 'ClientPresentationV2' }
        & PresentationString_ClientPresentationFragment
      ) | null } | null> | null } };

export type PresentationString_HouseholdFragment = { __typename?: 'Household', id: string, displayName: string, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, firstName: string, preferredName?: string | null, lastName: string, remainingGSTExclusion: CurrencyUSD, remainingLifetimeExclusion: CurrencyUSD }>, estateValueMetrics: { __typename?: 'HouseholdMetrics', totalEstateValue: CurrencyUSD, inEstateValue: CurrencyUSD, outOfEstateValue: CurrencyUSD } };

export type PresentationString_ClientPresentationFragment = { __typename?: 'ClientPresentationV2', id: string, createdAt: Time };

export const Operations = {
  Query: {
    PresentationString: 'PresentationString' as const
  },
  Fragment: {
    PresentationString_Household: 'PresentationString_Household' as const,
    PresentationString_ClientPresentation: 'PresentationString_ClientPresentation' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const PresentationString_HouseholdFragmentDoc = gql`
    fragment PresentationString_Household on Household {
  id
  displayName
  possiblePrimaryClients {
    id
    firstName
    preferredName
    lastName
    remainingGSTExclusion
    remainingLifetimeExclusion
  }
  estateValueMetrics {
    totalEstateValue
    inEstateValue
    outOfEstateValue
  }
}
    `;
export const PresentationString_ClientPresentationFragmentDoc = gql`
    fragment PresentationString_ClientPresentation on ClientPresentationV2 {
  id
  createdAt
}
    `;
export const PresentationStringDocument = gql`
    query PresentationString($householdID: ID!, $presentationID: ID!, $hasPresentationID: Boolean!) {
  households(where: {id: $householdID}) {
    edges {
      node {
        ...PresentationString_Household
      }
    }
  }
  clientPresentationV2s(where: {id: $presentationID}) @include(if: $hasPresentationID) {
    edges {
      node {
        ...PresentationString_ClientPresentation
      }
    }
  }
}
    ${PresentationString_HouseholdFragmentDoc}
${PresentationString_ClientPresentationFragmentDoc}`;

/**
 * __usePresentationStringQuery__
 *
 * To run a query within a React component, call `usePresentationStringQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresentationStringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresentationStringQuery({
 *   variables: {
 *      householdID: // value for 'householdID'
 *      presentationID: // value for 'presentationID'
 *      hasPresentationID: // value for 'hasPresentationID'
 *   },
 * });
 */
export function usePresentationStringQuery(baseOptions: Apollo.QueryHookOptions<PresentationStringQuery, PresentationStringQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PresentationStringQuery, PresentationStringQueryVariables>(PresentationStringDocument, withFetchPolicyContext(options));
      }
export function usePresentationStringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PresentationStringQuery, PresentationStringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PresentationStringQuery, PresentationStringQueryVariables>(PresentationStringDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function usePresentationStringSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PresentationStringQuery, PresentationStringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PresentationStringQuery, PresentationStringQueryVariables>(PresentationStringDocument, withFetchPolicyContext(options));
        }
export type PresentationStringQueryHookResult = ReturnType<typeof usePresentationStringQuery>;
export type PresentationStringLazyQueryHookResult = ReturnType<typeof usePresentationStringLazyQuery>;
export type PresentationStringSuspenseQueryHookResult = ReturnType<typeof usePresentationStringSuspenseQuery>;
export type PresentationStringQueryResult = Apollo.QueryResult<PresentationStringQuery, PresentationStringQueryVariables>;